import styled, { Color, Font, Spacing, Breakpoint } from '@nfinite/react-hubstairs/styled'
import TextLink from 'components/Commons/TextLink'

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${Spacing.generateMargin({ top: 'xxl' })}
  text-align: center;
`

export const Title = styled('p')`
  ${Font.generate({ size: 'l', weight: 'bold' })}
  ${Spacing.generateMargin({ top: '0', bottom: 'm' })}
  
  ${Breakpoint.greaterThanMobile()} {
    ${Font.generate({ size: 'xl' })}
  }
`

export const Message = styled('p')`
  color: ${Color.get('text', 'gray')};
  ${Spacing.generateMargin({ vertical: '0' })}
`

export const Contact = styled(TextLink)`
  text-decoration: underline;
`
